import styled from '@emotion/styled'

export const InnerSection = styled.div<{inverse?: boolean}>`
  align-items: center;
  display: flex;
  justify-content: space-between;
  max-width: 1440px;
  padding: 0 1rem;
  width: 100%;
  flex-direction: ${props => props.inverse ? 'row-reverse' : 'row'};

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`

export const AlwaysRowInnerSection = styled.div<{inverse?: boolean}>`
  align-items: center;
  display: flex;
  justify-content: space-between;
  max-width: 1440px;
  padding: 0 1rem;
  width: 100%;
  flex-direction: ${props => props.inverse ? 'row-reverse' : 'row'};

  @media (max-width: 768px) {
    gap: 1rem;
  }
`
